var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mobile-multiselect",
    _vm._g(
      _vm._b(
        {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(slotProps) {
                return [
                  _c(
                    "div",
                    { staticClass: "mobile-multiselect-size__inner" },
                    _vm._l(slotProps.options, function(option) {
                      return _c("size", {
                        key: option.id,
                        staticClass: "scrollable",
                        attrs: {
                          "is-selected": slotProps.isSelected(option),
                          title: option.label,
                          size: "large",
                          "is-out-of-stock": option.count === 0
                        },
                        nativeOn: {
                          click: function($event) {
                            return slotProps.toggle(option)
                          }
                        }
                      })
                    }),
                    1
                  )
                ]
              }
            }
          ])
        },
        "mobile-multiselect",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }